(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sv-pup-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  for (const menu of document.querySelectorAll('.sv-pup-menu[open]')) {
    if (!menu.contains(event.target)) menu.open = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  for (const menu of document.querySelectorAll('.sv-pup-menu[open]')) {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  }
});
  } catch(e) { console.error(e); }
})();

})();
